import get from 'lodash/get'

// Get

export const currentId = (state) => get(state, 'helloBar.currentId')
export const delay = (state) => get(state, 'helloBar.delay')
export const campaignId = (state) => get(state, 'helloBar.campaignId')

// Boolean

export const isActive = (state) => !!get(state, 'helloBar.isActive')
export const isOpen = (state) => !!get(state, 'helloBar.isOpen')
